import { useQuery } from "@tanstack/react-query"
import { USER_DETAILS_KEY } from "../../../constants"
import { UserProfile } from "../../../types"
import { useAuthService } from "../services/useAuthService"

type UseUserProfileType = {
  profile: UserProfile | null
  isLoading: boolean
}

const useUserProfile = (): UseUserProfileType => {

  const authService = useAuthService()

  const { data: profile, isLoading } = useQuery({
    queryKey: [USER_DETAILS_KEY],
    queryFn: async (): Promise<UserProfile> => {
      return authService.getProfile()
    },
    select: (data: UserProfile): UserProfile => {
      const workspaces = (data.workspaces ?? []).filter(workspace => {
        return workspace?.id
      })
      const activeWorkspace = (data.active_workspace ?? []).filter(workspace => {
        return workspace?.id
      })
      const profile: UserProfile = {
        active_workspace: activeWorkspace,
        user: data.user,
        location: data.location ?? null,
        workspaces,
        can_create_workspace: data.can_create_workspace
      }
      return profile
    }
  })

  return {
    profile: profile ?? null,
    isLoading,
  }
}

export default useUserProfile
